import React from 'react'
import Icon from './Icon'

function RocketIcon(props) {
  return <Icon solid label="rocket" {...props} />
}

export default RocketIcon;
